var React = require('react');

function TvGuide (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"3","y":"3","width":"6","height":"6","fill":"currentColor","stroke":"currentColor","strokeWidth":"2","key":0}),React.createElement("rect",{"x":"3","y":"15","width":"6","height":"6","stroke":"currentColor","strokeWidth":"2","key":1}),React.createElement("rect",{"x":"15","y":"3","width":"6","height":"6","stroke":"currentColor","strokeWidth":"2","key":2}),React.createElement("rect",{"x":"15","y":"15","width":"6","height":"6","stroke":"currentColor","strokeWidth":"2","key":3})]);
}

TvGuide.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = TvGuide;

TvGuide.default = TvGuide;
